module.exports = __webpack_public_path__ + "static/media/Soul soffa 3-sits divan XL genisis lion detalj 2023 3.4a626a26.jpg";